import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/reset.css'
import App from './App';
import MainTop from './components/MainTop/MainTop';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MainTop />
  </React.StrictMode>
);


